export default function isMaster() {
  try {
    const account = JSON.parse(localStorage.getItem('name'));
    return account?.role?.value?.toLowerCase() === 'master';
  } catch (error) {
    return false;
  }
}
